import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('tbolt_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('tbolt_token');
      localStorage.removeItem('tbolt_user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

// Auth
export const signup      = (data)       => api.post('/auth/signup', data);
export const login       = (data)       => api.post('/auth/login', data);
export const getMe       = ()           => api.get('/auth/me');
export const updateSplit = (spendBps)   => api.put('/auth/split', { spendBps });
export const lookupUser  = (identifier) => api.get(`/auth/lookup?identifier=${encodeURIComponent(identifier)}`);
export const searchUsers = (q)          => api.get(`/auth/search?q=${encodeURIComponent(q)}`);

// Payments
export const getBalance           = ()                           => api.get('/payments/balance');
export const getHistory           = ()                           => api.get('/payments/history?limit=500');
export const getHistoryPage       = (limit, offset)              => api.get(`/payments/history?limit=${limit}&offset=${offset}`);
export async function getAllHistory() {
  const PAGE = 50;
  let offset = 0;
  let all = [];
  while (true) {
    const res = await api.get(`/payments/history?limit=${PAGE}&offset=${offset}`);
    const page = res.data || [];
    all = all.concat(page);
    if (page.length < PAGE) break;
    offset += PAGE;
  }
  return all;
}
export const depositIntent        = (amountCents)                => api.post('/payments/deposit/intent', { amountCents });
export const depositConfirm       = (paymentIntentId)            => api.post('/payments/deposit/confirm', { paymentIntentId });
export const sendPayment          = (identifier, amountCents)    => api.post('/payments/send', { identifier, amountCents });
export const cashoutSpend         = (amountCents, bankAccountId) => api.post('/payments/cashout/spend', { amountCents, bankAccountId });
export const cashoutSave          = (satoshis, bankAccountId)    => api.post('/payments/cashout/save', { satoshis, bankAccountId });
export const moveFunds            = (fromBucket, amountCents)    => api.post('/payments/move', { fromBucket, amountCents });
export const createPaymentRequest = (data)                       => api.post('/payments/request/create', data);
export const getPaymentRequest    = (id)                         => api.get(`/payments/request/${id}`);
export const payPaymentRequest    = (id)                         => api.post(`/payments/request/${id}/pay`);
export const getSettings          = ()                           => api.get('/payments/settings');
export const updateSettings       = (data)                       => api.put('/payments/settings', data);
export const getPlatformSettings  = ()                           => api.get('/platform-settings');
export const getContacts          = ()                           => api.get('/payments/contacts');
export const createContact        = (data)                       => api.post('/payments/contacts', data);
export const updateContact        = (id, data)                   => api.put(`/payments/contacts/${id}`, data);
export const deleteContact        = (id)                         => api.delete(`/payments/contacts/${id}`);

// Bank accounts
export const getBankAccounts   = ()     => api.get('/payments/bank-accounts');
export const addBankAccount    = (data) => api.post('/payments/bank-accounts', data);
export const setPrimaryAccount = (id)   => api.put(`/payments/bank-accounts/${id}/primary`);
export const deleteBankAccount = (id)   => api.delete(`/payments/bank-accounts/${id}`);

export default api;

export const getPublicPaymentRequest = (id)        => api.get(`/pay/request/${id}`);
export const createGuestPayIntent    = (requestId) => api.post(`/pay/guest/${requestId}`);
